// Carry Roll OfflineView — lateral side-finish (7.3).

import { useResult } from '../../store/selectors';
import { useStore } from '../../store';
import { mToYd } from '@carry-roll/shared-logic';

export function OfflineView() {
  const result = useResult();
  const distanceUnit = useStore((s) => s.distanceUnit);
  const offline = result.offlineM;
  const conv = distanceUnit === 'yd' ? mToYd(Math.abs(offline)) : Math.abs(offline);
  const dir = offline > 0.5 ? 'right' : offline < -0.5 ? 'left' : 'center';

  return (
    <div data-testid="offline-view" className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
      ◆ Side finish: {Math.round(conv)} {distanceUnit} {dir}
    </div>
  );
}
